/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import { FormControl } from 'react-bootstrap';
import SubmitTitle from './SubmitTitle';
import AOForm from '../../../shared/AOForm';

const ReferenceCodeInput = (props) => {
    const { 
        i18n,
        backAction,
        submitRefeCodeAction,
        referenceCode,
        referCodeAction,
        disabled,
        isDisplayErr,
        inputErrMsg
    } = props;
    let hideErrMsg = isDisplayErr ? "" : "hidden";
    return i18n ? (
        <div className={"editApp-container"}>
            <SubmitTitle 
                i18n={i18n.editAppTitle}
                isShowIcon={false}/> 
            <div className="refeCode-body">
                <div>
                    <label htmlFor="referenceCodeTitle" data-key="refeCode">{i18n.refeCode}</label>
                </div>
                <FormControl
                    role="textbox"
                    aria-invalid={!disabled}
                    aria-required={true}
                    id="referenceCodeTitle"
                    maxLength={8}
                    data-key={"refeCode-input"}
                    type="text"
                    inputRef={referenceCode}
                    onInput={referCodeAction}
                    />
                <div className={"logon-mobile-info " + hideErrMsg}>
                    <div className={"icon icon-circle-delete icon-logon logon-input-info logon-input-err "}>
                        <span aria-hidden={isDisplayErr} data-key={"logon_errPhnMsg"}>{inputErrMsg}</span>
                    </div> 
                </div>
            </div>
            <AOForm.BottomButtonsGroup
                disabled={disabled}
                saveButtonShow = {false}
                content={i18n.btnContent}
                backAction={backAction}
                completeFormAction={submitRefeCodeAction}
            /> 
        </div>
    ) : null;
};
export default ReferenceCodeInput;


// WEBPACK FOOTER //
// ./src/views/Appointment/components/ReferenceCodeInput.js